/** @format */
import approvalStateBadgeTpl from './approvalStateBadge.tpl.html';

export const approvalStateBadgeModule = 'sis-components.approvalState.approvalStateBadge';

(function () {
    angular
        .module(approvalStateBadgeModule, [])
        .directive('approvalStateBadge', approvalStateBadgeDirective)
        .controller('approvalStateBadgeController', approvalStateBadgeController);

    function approvalStateBadgeDirective() {
        return {
            restrict: 'E',
            scope: {
                module: '<?',
                service: '<',
            },
            controller: 'approvalStateBadgeController as ctrl',
            template: approvalStateBadgeTpl,
            bindToController: true,
        };
    }

    function approvalStateBadgeController() {}
})();
